import React, { useState } from 'react';
import { noHeadingEditorConfig } from '../../../../../common/components/RichTextEditor/CKEditorConfig';

import RichTextEditor from '../../../../../common/components/RichTextEditor/RichTextEditor';

const AdditionalCommentsForm = ({
  additionalComments,
  onChange,
  lightModeVariant,
}) => {
  const [focused, setFocused] = useState(false);
  return (
    <div
      className={`additional-comments${
        lightModeVariant ? ' light-mode-variant' : ''
      }`}
    >
      <p>
        If you would like to add any comments in association to this section,
        please mention below.
      </p>
      <p className="additional-comments-label">Additional Comments</p>
      <RichTextEditor
        richTextData={additionalComments}
        onChange={onChange}
        config={noHeadingEditorConfig}
        onBlur={(_, editor) => {
          setFocused(false);
          editor.ui.view.toolbar.element.style.display = 'none';
        }}
        onFocus={(_, editor) => {
          setFocused(true);
          editor.ui.view.toolbar.element.style.display = 'block';
        }}
        isFocused={focused}
      />

      <p>
        When you are happy with your responses please submit to allow use to
        proceed.
      </p>
    </div>
  );
};

export default AdditionalCommentsForm;
